import React from 'react';
import { motion } from 'framer-motion';

function Faq() {
  const faqItems = [
    {
      question: "What is Black Stone Crypto?",
      answer: "Black Stone is a leading cryptocurrency platform offering secure, fast, and reliable digital asset solutions. We provide trading, wallets, staking, and blockchain investment opportunities for individuals and institutions alike.",
    },
    {
      question: "How can I get started with Black Stone Crypto?",
      answer: "Getting started is simple. Create an account on our platform, complete the KYC process, and fund your wallet. You can start trading or investing in crypto assets in minutes.",
    },
    {
      question: "Is my investment safe with Black Stone?",
      answer: "Yes! We use state-of-the-art security protocols, cold storage for assets, multi-factor authentication, and regular security audits to ensure your funds and data are fully protected.",
    },
    {
      question: "Does Black Stone support Bitcoin and other cryptocurrencies?",
      answer: "Absolutely. We support major cryptocurrencies like Bitcoin, Ethereum, and others. Additionally, we provide access to select altcoins and token sales with high growth potential.",
    },
    {
      question: "What are the fees for transactions and withdrawals?",
      answer: "Our fees are highly competitive. Transaction fees vary by cryptocurrency and network, while withdrawal fees are transparent and updated in real-time on the platform.",
    },
    {
      question: "How can I contact Black Stone support?",
      answer: "Our support team is available 24/7 via live chat, email, and phone. We provide dedicated assistance to ensure smooth transactions and resolve any issues quickly.",
    },
    {
      question: "Can I invest globally using Black Stone?",
      answer: "Yes, Black Stone allows global users to invest in crypto assets, subject to local regulations. We provide multi-currency support and seamless cross-border transactions.",
    }
  ];

  const fadeInUp = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
  };

  return (
    <section id="faq" className="hero-section">
      <motion.section
        className="container my-5 text-center"
        initial={{ y: 30, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        viewport={{ once: true, amount: 0.6 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <h2 className="fw-bold responsive-heading">
          Frequently <span className="highlight-text">Asked</span> Questions
        </h2>
        <h5 className="mt-2 text-muted">
          Find answers to common questions about Black Stone Crypto and our platform.
        </h5>
      </motion.section>

      <div className="container my-5">
        <div className="accordion" id="faqAccordion">
          {faqItems.map((faq, index) => (
            <motion.div
              variants={fadeInUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              className="accordion-item shadow mb-3 rounded p-2"
              key={index}
              style={{ boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}
            >
              <h2 className="accordion-header" id={`heading-${index}`}>
                <button
                  className="accordion-button collapsed fw-bold"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse-${index}`}
                  aria-expanded="false"
                  aria-controls={`collapse-${index}`}
                  style={{
                    fontWeight: '700',
                    backgroundColor: '#fff',
                    whiteSpace: 'normal',
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word',
                  }}
                >
                  {faq.question}
                </button>
              </h2>
              <div
                id={`collapse-${index}`}
                className="accordion-collapse collapse"
                aria-labelledby={`heading-${index}`}
                data-bs-parent="#faqAccordion"
              >
                <div
                  className="accordion-body"
                  style={{ backgroundColor: '#fff4e6' }}
                >
                  {faq.answer}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Faq;
